import React from 'react'
import styles from './SettingsMenu.scss'
import {Icon} from 'common/Icon'
import {PopoverMenu, PopoverMenuItem, PopoverMenuHeading} from 'common/styleguide/PopoverMenu'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import {CheckboxGroup} from 'common/styleguide/CheckboxGroup'
import cx from 'classnames'
import {OrderedMap, Set} from 'immutable'

const overlays = OrderedMap({
  showPOIs: 'Points of Interest',
  // showBikePaths: 'Bike Paths',
  showDistanceMarkers: 'Distance Markers'
})

const options = OrderedMap({
  // showPOIs: 'Points of Interest',
  // showBikePaths: 'Bike Paths',
  scrollWheelZoom: 'Zoom by Scrolling'
})

export class SettingsMenu extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isMounted: false,
      menuOpen: false
    }
  }

  componentDidMount () {
    this.setState({isMounted: true})
  }

  toggle = () => {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  onToggleOverlay = (overlayKey) => {
    const {mapSettings} = this.props
    if (overlayKey === 'showDistanceMarkers') {
      this.props.onDistanceMarkersChange(!mapSettings.showDistanceMarkers)
    }
    if (overlayKey === 'showPOIs') {
      this.props.onPOIsChange(!mapSettings.showPOIs)
    }
  }

  onToggleZoom = (set) => {
    this.props.onScrollWheelZoomChange(set.has('scrollWheelZoom'))
  }

  render () {
    const {isMounted, menuOpen} = this.state
    const {mapSettings, unitsOptions, onUnitsChange} = this.props

    const activeOverlays = overlays.keySeq().filter(k => mapSettings[k]).toSet()

    return (
      <div className={styles.SettingsMenu}>
        <button ref={r => { this._button = r }} onClick={this.toggle} className={cx(menuOpen && styles.active)}><Icon i='ios-settings' /> Settings</button>
        {isMounted && menuOpen && <PopoverMenu
          target={this._button}
          container={window.body}
          placement='bottom'
          onRequestClose={() => this.setState({menuOpen: false})} >
          <PopoverMenuHeading>Map Overlays</PopoverMenuHeading>
          <PopoverMenuItem>
            <CheckboxGroup
              style={{margin: '0 0'}}
              horizontal
              options={overlays}
              selected={activeOverlays}
              onToggleItem={this.onToggleOverlay} />
          </PopoverMenuItem>
          <PopoverMenuHeading>Options</PopoverMenuHeading>
          <PopoverMenuItem>
            <CheckboxGroup
              style={{margin: '0 0'}}
              horizontal
              options={options}
              selected={mapSettings.scrollWheelZoom ? Set(['scrollWheelZoom']) : Set()}
              onChange={this.onToggleZoom} />
          </PopoverMenuItem>
          <PopoverMenuHeading>Units</PopoverMenuHeading>
          <PopoverMenuItem>
            <RadioGroup
              horizontal
              style={{margin: '0 0'}}
              options={unitsOptions}
              selected={mapSettings.metricUnits ? 'metric' : 'imperial'}
              onChange={onUnitsChange} />
          </PopoverMenuItem>
        </PopoverMenu>}
      </div>
    )
  }
}
